import React, { useState } from 'react'
import axios from 'axios'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { API_BASE_URL } from '../config/api'
import { useAuth } from '../context/AuthContext'
import './Auth.css'

function Login() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')
    const { login } = useAuth()
    const navigate = useNavigate()
    const location = useLocation()

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            const response = await axios.post(
                `${API_BASE_URL}/auth/login`,
                { email, password }
            )
            login(response.data.token, email)
            // return to the page that sent the user here, else home (the wheel)
            const dest = location.state?.from || '/'
            navigate(dest, { replace: true })
        } catch (err) {
            const msg = err?.response?.data?.message || err?.response?.data || 'Could not sign in. Check your details.'
            setError(typeof msg === 'string' ? msg : 'Could not sign in.')
        }
    }

    return (
        <div className="auth-stage">
            <div className="auth-card">
                <span className="auth-kicker">iFelt</span>
                <h1 className="auth-title">Welcome back</h1>

                <form className="auth-form" onSubmit={handleSubmit}>
                    <div className="auth-field">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            placeholder="you@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoFocus
                        />
                    </div>

                    <div className="auth-field">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <button type="submit" className="auth-submit">Sign in</button>
                </form>

                {error && <p className="auth-error">{error}</p>}

                <p className="auth-switch">
                    New here? <Link to="/register">Create an account</Link>
                </p>
            </div>
        </div>
    )
}

export default Login
